import { useState, useEffect } from "react";

export function useHoverBackground(defaultColor, hoverColor) {
  const [bgColor, setBgColor] = useState(defaultColor);

  // keep bgColor in sync when defaultColor changes
  useEffect(() => {
    if (defaultColor) {
      setBgColor(defaultColor);
    }
  }, [defaultColor]);

  const onMouseEnter = () => {
    if (hoverColor) setBgColor(hoverColor);
  };

  const onMouseLeave = () => {
    if (defaultColor) setBgColor(defaultColor);
  };

  return {
    style: { backgroundColor: bgColor },
    onMouseEnter,
    onMouseLeave,
  };
}
